import { useMemo } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'

import overrides from './overrides'
import { palette } from './palette'
import { typography } from './typography'

const shadows = [
  'none',
  '0 8px 24px rgb(90 83 163 / 0.08)',
  '0 10px 28px rgb(90 83 163 / 0.08)',
  '0 14px 32px rgb(90 83 163 / 0.08)',
  ...Array(21).fill('0 20px 40px rgb(90 83 163 / 0.08)'),
]

export default function ThemeProvider({ children, mode = 'light' }) {
  const value = useMemo(
    () => ({
      palette: palette(mode),
      typography,
      shadows,
      shape: { borderRadius: 8 },
    }),
    [mode],
  )

  const theme = createTheme(value)
  theme.components = overrides(theme)

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </MUIThemeProvider>
  )
}
